import $ from "jquery";

$("body").on("click", (e) => {
  if (
    !$(e.target).hasClass(".officer-card") &&
    !$(e.target).parents(".officer-card").length
  ) {
    $(".officer-card").removeClass("visible");
  }
});

$(".officer-widget-avatar.big").on("click", (e) => {
  $(e.target).parents(".officer-card").toggleClass("visible");
  return false;
});

$(window).resize(() => {
  $(".officer-card").removeClass("visible");
});
